import { AxiosInstance } from '@service/axios-instance';
import type { ChecklistConfigDoc, ChecklistConfigListItem, ChecklistQuestion } from './types';

export async function getChecklistConfigs(db: string) {
  const res = await AxiosInstance.get<ChecklistConfigListItem[]>(
    `/checklist-configs/get_configs?db=${encodeURIComponent(db)}`,
    { withCredentials: true }
  );
  return res.data;
}

export async function getChecklistConfig(db: string, name: string, version?: number) {
  const params = new URLSearchParams({ db, name });
  if (version !== undefined) params.set('version', String(version));

  const res = await AxiosInstance.get(`/checklist-configs/get_config?${params.toString()}`, {
    withCredentials: true,
  });
  return res.data;
}

export async function saveChecklistConfig(
  db: string,
  payload: { name: string; notes?: string; questions: ChecklistQuestion[] }
) {
  const res = await AxiosInstance.post(
    `/checklist-configs/save_config?db=${encodeURIComponent(db)}`,
    payload,
    { withCredentials: true }
  );
  return res.data as { ok: boolean; name: string; version: number; id: string; error?: string };
}

export async function getListChecklistConfigsVersions(db: string) {
  const res = await AxiosInstance.get(
    `/checklist-configs/list_configs_versions?db=${encodeURIComponent(db)}`,
    { withCredentials: true }
  );
  return res.data as { id: string; name: string; version: number; createdAt?: string }[];
}

export async function getAllQuestionsMap(db: string) {
  const res = await AxiosInstance.get<Record<string, { text: string; answers: { value: string; label: string }[] }[]>>(
    `/checklist-configs/all_questions_map?db=${encodeURIComponent(db)}`,
    { withCredentials: true }
  );
  return res.data;
}

export interface ChecklistConfigVersion {
  id: string;
  name: string;
  version: number;
  createdAt?: string;
}

export async function assignChecklistToDevice(db: string, deviceId: string, checklistId: string, skipMinutes?: number | null, timeoutMin?: number | null, forceAutologin?: boolean | null) {
  const res = await AxiosInstance.post(
    `/checklist-configs/assign_checklist?db=${encodeURIComponent(db)}`,
    {
      device_id: deviceId,
      checklist_config_id: checklistId,
      checklist_skip_minutes: skipMinutes,
      checklist_timeout_min: timeoutMin,
      force_autologin: forceAutologin
    },
    { withCredentials: true }
  );
  return res.data;
}

export async function assignChecklistToDeviceBulk(db: string, updates: any[]) {
  const res = await AxiosInstance.post(
    `/checklist-configs/assign_checklist_bulk?db=${encodeURIComponent(db)}`,
    { updates },
    { withCredentials: true }
  );
  return res.data;
}


export interface Equipament {
  id: string;
  tid: number;
  tipo: string;
  marca: string;
  modelo: string;
  ano: string;
  setor: string;
  apelido?: string;
  checklist_version?: string; // from backend
  cv?: string; // alias
  checklist_skip_minutes?: number;
  checklist_timeout_min?: number;
  force_autologin?: boolean;
  firmware_version?: string;
  actual_firmware_version?: string;
}

export async function getEquipaments(db: string, filters: Record<string, string> = {}) {
  const res = await AxiosInstance.post(
    `/equipaments/get_equipaments?db=${encodeURIComponent(db)}`,
    {
      match_filters_dict: filters,
    },
    { withCredentials: true }
  );

  // Backend returns list directly.
  return res.data as Equipament[];
}

export async function getSectors(db: string) {
  const res = await AxiosInstance.get(`/equipaments/get_sectors?db=${encodeURIComponent(db)}`, {
    withCredentials: true
  });
  return res.data as string[];
}
